<template>
	<div class="contact-form-wrapper wow move-up " v-bind:class="{ 'p-4' : boolEmbeded, 'sam-shadow' : useShadow }">
		<p v-if="boolEmbeded" class="cta-sentence pb-2 text-center" style="white-space: pre-line;">{{ ctaText }}</p>
		<form id="contact-form" class="form-styling" @submit.prevent="submit">

			<!-- Honeypot field - hidden from humans, bots will fill it -->
			<div class="ohnohoney">
				<input type="text" v-model="form.website" name="website" autocomplete="off" tabindex="-1" />
			</div>

			<div class="contact-page-form">
				<div class="contact-input">
					<div class="contact-inner">
						<input v-model="$v.form.first_name.$model" id="first_name" :placeholder="$t('form.firstName')" minlength="2" maxlength="40" name="first_name" size="20" type="text" />
						<div v-if="$v.form.first_name.$error">
							<p v-if="!$v.form.first_name.required" class="text-danger my-1 mx-1">{{ $t('form.error.firstName.required') }}</p>
							<p v-if="!$v.form.first_name.minLength||!$v.form.first_name.maxLength" class="text-danger my-1 mx-1">{{ $t('form.error.firstName.length') }}</p>
						</div>
					</div>
					<div class="contact-inner">
						<input v-model="$v.form.last_name.$model" id="last_name" :placeholder="$t('form.lastName')" maxlength="80" name="last_name" size="20" type="text" />
						<div v-if="$v.form.last_name.$error">
							<p v-if="!$v.form.last_name.required" class="text-danger my-1 mx-1">{{ $t('form.error.lastName.required') }}</p>
							<p v-if="!$v.form.last_name.minLength||!$v.form.last_name.maxLength" class="text-danger my-1 mx-1">{{ $t('form.error.lastName.length') }}</p>
						</div>
					</div>
				</div>
				<div class="contact-inner">
					<input v-model="$v.form.email.$model" id="email" :placeholder="$t('form.email')" maxlength="60" name="email" size="20" type="email" />
					<div v-if="$v.form.email.$error">
						<p v-if="!$v.form.email.required" class="text-danger my-1 mx-1">{{ $t('form.error.email.required') }}</p>
						<p v-if="!$v.form.email.email" class="text-danger my-1 mx-1">{{ $t('form.error.email.email') }}</p>
						<p v-if="!$v.form.email.maxLength" class="text-danger my-1 mx-1">{{ $t('form.error.email.maxLength') }}</p>
					</div>
				</div>

				<div class="contact-inner">
					<input v-model="$v.form.phone.$model" id="phone" :placeholder="$t('form.phone')" name="phone" size="20" type="tel" />
					<div v-if="$v.form.phone.$error">
						<p v-if="!$v.form.phone.required" class="text-danger my-1 mx-1">{{ $t('form.error.phone.required') }}</p>
						<p v-if="$v.form.phone.$model && !$v.form.phone.pattern" class="text-danger my-1 mx-1">{{ $t('form.error.phone.invalid') }}</p>
					</div>
				</div>
				<div class="contact-inner">
					<input v-model="$v.form.company.$model" id="company" :placeholder="$t('form.company')" minlength="2" maxlength="100" name="company" size="20" type="text" />
					<div v-if="$v.form.company.$error">
						<p v-if="!$v.form.company.required" class="text-danger my-1 mx-1">{{ $t('form.error.company.required') }}</p>
						<p v-if="!$v.form.company.minLength||!$v.form.company.maxLength" class="text-danger my-1 mx-1">{{ $t('form.error.company.length') }}</p>
					</div>
				</div>
				<div class="contact-inner">
					<input v-model="form.city" id="city" :placeholder="$t('form.city')" name="city" size="20" type="text" />
				</div>
				<div class="contact-inner">
					<select id="serviceWanted" v-model="form.serviceWanted" style="color: #818181 !important;"
					:disabled="serviceWanted">
						<option value="">{{ $t('form.serviceWantedOptions.empty') }}</option>
						<option v-for="option in serviceOptionsComputed" :key="option.value" :value="option.value">
							{{ option.label }}
						</option>
					</select>
				</div>
				<div class="contact-inner contact-message">
					<textarea v-model="form.description" id="description" :placeholder="$t('form.comments')" maxlength="32000" name="description"></textarea>
				</div>
				<div v-if="submitError" class="text-danger text-center my-2">
					{{ $i18n.locale === 'fr' ? 'Une erreur est survenue. Veuillez réessayer.' : 'An error occurred. Please try again.' }}
				</div>
				<div class="contact-submit-btn d-flex justify-content-center">
					<button class="ht-btn ht-btn-md" v-bind:class="{ 'w-50': boolEmbeded, 'w-25': !boolEmbeded }" type="submit" :disabled="isSubmitting">
						<span v-if="isSubmitting">{{ $i18n.locale === 'fr' ? 'Envoi...' : 'Sending...' }}</span>
						<span v-else>{{ $t('form.submit') }}</span>
					</button>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
	import { required, minLength, maxLength, email } from 'vuelidate/lib/validators';

	export default {
		name: 'ContactForm',
		props: [
			'boolEmbeded',
			'ctaText',
			'serviceWanted',
			'serviceOptions',
			'useShadow'
		],
		data () {
			return {
				isSubmitting: false,
				submitError: false,
				formLoadTime: null,
				minSubmitTime: 3000, // Minimum 3 seconds before form can be submitted
				googleSheetUrl: 'https://script.google.com/macros/s/AKfycbzawHEzx7Wh5fvufYdYudFRWyqes_DGvk46KZ25hCJDTXahmIiJxP8QFH7I5xcRD_DSmA/exec',
				domainCode: '3D',
				form: {
					first_name: '',
					last_name: '',
					email: '',
					phone: '',
					company: '',
					city: '',
					description: '',
					serviceWanted: '',
					website: '', // Honeypot field
					webSourceDetail: window.location.href.split("?")[0],
					utm: {
						campaign: '',
						medium: '',
						source: '',
						term: '',
						gclid: ''
					}
				}
			}
		},

		computed: {
			serviceOptionsComputed() {
				if (this.serviceOptions && this.serviceOptions.length) {
					return this.serviceOptions;
				}
				return [
					{ value: 'Demande de soumission', label: this.$t('form.serviceWantedOptions.quote') },
					{ value: 'Question générale', label: this.$t('form.serviceWantedOptions.general') },
					{ value: 'Support technique', label: this.$t('form.serviceWantedOptions.support') },
					{ value: 'Demande de démonstration', label: this.$t('form.serviceWantedOptions.demo') }
				];
			}
		},

		validations: {
			form:{
				first_name: {
					required,
					minLength: minLength(2),
					maxLength: maxLength(40)
				},
				last_name: {
					required,
					minLength: minLength(2),
					maxLength: maxLength(80)
				},
				email: {
					required,
					maxLength: maxLength(60),
					email
				},
				phone: {
					required,
					pattern: value => /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(value)
				},
				company: {
					required,
					minLength: minLength(2),
					maxLength: maxLength(100)
				}
			}
		},
		mounted(){
			this.formLoadTime = Date.now();
			this.setUtmCookieTracking();

			if(this.serviceWanted){
				this.form.serviceWanted = this.serviceWanted;
			}
		},
		methods: {
			setUtmCookieTracking(){
				const urlParams = new URLSearchParams(window.location.search);

				let campaignUtm = urlParams.get('utm_campaign') ? encodeURIComponent(urlParams.get('utm_campaign')) : null;
				let mediumUtm = urlParams.get('utm_medium') ? encodeURIComponent(urlParams.get('utm_medium')) : null;
				let sourceUtm = urlParams.get('utm_source') ? encodeURIComponent(urlParams.get('utm_source')) : null;
				let termUtm = urlParams.get('utm_term') ? encodeURIComponent(urlParams.get('utm_term')) : null;
				let gclidUtm = urlParams.get('gclid') ? encodeURIComponent(urlParams.get('gclid')) : null;

				const utmCookies = this.$cookies.get('cookieUtms') || {};

				let objectCookies = {
					campaignUtm: campaignUtm == null ? utmCookies.campaignUtm : campaignUtm,
					mediumUtm: mediumUtm == null ? utmCookies.mediumUtm : mediumUtm,
					sourceUtm: sourceUtm == null ? utmCookies.sourceUtm : sourceUtm,
					termUtm: termUtm == null ? utmCookies.termUtm : termUtm,
					gclidUtm: gclidUtm == null ? utmCookies.gclidUtm : gclidUtm
				};

				this.$cookies.set('cookieUtms', objectCookies);

				this.form.utm.campaign = objectCookies.campaignUtm || '';
				this.form.utm.medium = objectCookies.mediumUtm || '';
				this.form.utm.source = objectCookies.sourceUtm || '';
				this.form.utm.term = objectCookies.termUtm || '';
				this.form.utm.gclid = objectCookies.gclidUtm || '';
			},
			async submit(){
				this.$v.$touch();
				
				if(this.$v.$invalid){
					return;
				}

				// Anti-spam: Check honeypot field
				if(this.form.website !== '') {
					console.warn('Bot detected: honeypot field filled');
					// Silently redirect to thank you page (don't let bot know it was caught)
					this.$router.push(this.$t('links.remerciement'));
					return;
				}

				// Anti-spam: Check time since form load
				const timeElapsed = Date.now() - this.formLoadTime;
				if(timeElapsed < this.minSubmitTime) {
					console.warn('Bot detected: form submitted too quickly');
					// Silently redirect to thank you page
					this.$router.push(this.$t('links.remerciement'));
					return;
				}

				this.isSubmitting = true;
				this.submitError = false;

				const payload = {
					domainCode: this.domainCode,
					first_name: this.form.first_name,
					last_name: this.form.last_name,
					email: this.form.email,
					phone: this.form.phone,
					company: this.form.company,
					city: this.form.city,
					description: this.form.description,
					serviceWanted: this.form.serviceWanted,
					webSourceDetail: this.form.webSourceDetail,
					utm_campaign: this.form.utm.campaign,
					utm_medium: this.form.utm.medium,
					utm_source: this.form.utm.source,
					utm_term: this.form.utm.term,
					utm_gclid: this.form.utm.gclid
				};

				try {
					await fetch(this.googleSheetUrl, {
						method: 'POST',
						mode: 'no-cors',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify(payload)
					});

					// With no-cors, we can't read the response, but if no error thrown, assume success
					this.$router.push(this.$t('links.remerciement'));

				} catch (error) {
					console.error('Form submission error:', error);
					this.submitError = true;
					this.isSubmitting = false;
				}
			}
		}
	}
</script>

<style scoped>
/* Honeypot field - hidden from humans but visible to bots */
.ohnohoney {
	opacity: 0;
	position: absolute;
	top: 0;
	left: 0;
	height: 0;
	width: 0;
	z-index: -1;
}

.sam-shadow{
	box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 12px -5px !important;
    border: 1px solid #e4e4e4 !important;
    border-radius: 10px !important;
}
</style>